module.exports = __webpack_public_path__ + "static/media/backend.46f6d4b5.svg";